/* Calculateur de chemin de vie — DailyLama
   Maquette : Claude Design « Chemin de vie.dc.html ».

   Trois couches nettement séparées :
   - le domaine (validation, calcul, partage, assainissement de la mesure) est pur,
     sans DOM ni réseau, et c'est lui qui est testé ;
   - monter() branche le DOM ;
   - la date de naissance ne quitte jamais la mémoire de la page. Aucune écriture en
     stockage, aucun paramètre d'URL, aucune propriété de mesure dérivée de la date.
*/
(function (global) {
  'use strict';

  var ANNEE_MIN = 1900;
  var MAITRES = [11, 22, 33];

  /* ------------------------------------------------------------------ */
  /* Domaine                                                             */
  /* ------------------------------------------------------------------ */

  function estEntier(valeur) {
    if (typeof valeur === 'number') return Number.isInteger(valeur);
    var t = String(valeur === null || valeur === undefined ? '' : valeur).trim();
    return t !== '' && /^\d+$/.test(t);
  }

  function nombre(valeur) { return Number(String(valeur).trim()); }

  /* Validation grégorienne stricte.
     On ne s'appuie pas sur la normalisation automatique de Date : new Date(1990, 1, 31)
     devient le 3 mars sans broncher. On construit en UTC et on vérifie que l'année,
     le mois et le jour reviennent identiques. */
  function validerDate(jour, mois, annee, aujourdhui) {
    var maintenant = aujourdhui instanceof Date ? aujourdhui : new Date();

    if (!estEntier(jour)) return { ok: false, champ: 'jour', code: 'jour_manquant',
      message: 'Indiquez votre jour de naissance.' };
    if (!estEntier(mois)) return { ok: false, champ: 'mois', code: 'mois_manquant',
      message: 'Indiquez votre mois de naissance.' };
    if (!estEntier(annee)) return { ok: false, champ: 'annee', code: 'annee_manquante',
      message: 'Indiquez votre année de naissance.' };

    var j = nombre(jour), m = nombre(mois), a = nombre(annee);
    var anneeMax = maintenant.getFullYear();

    if (a < ANNEE_MIN || a > anneeMax) {
      return { ok: false, champ: 'annee', code: 'annee_hors_bornes',
        message: 'Indiquez une année comprise entre ' + ANNEE_MIN + ' et ' + anneeMax + '.' };
    }

    var d = new Date(Date.UTC(a, m - 1, j));
    var existe = d.getUTCFullYear() === a && d.getUTCMonth() === m - 1 && d.getUTCDate() === j;
    if (!existe) {
      return { ok: false, champ: j > 28 ? 'jour' : 'mois', code: 'date_inexistante',
        message: 'Cette date n’existe pas.' };
    }

    var finDuJour = Date.UTC(maintenant.getFullYear(), maintenant.getMonth(), maintenant.getDate());
    if (d.getTime() > finDuJour) {
      return { ok: false, champ: 'annee', code: 'date_future',
        message: 'La date de naissance ne peut pas être dans le futur.' };
    }

    return { ok: true, jour: j, mois: m, annee: a };
  }

  function chiffresDe(n) { return String(n).split('').map(Number); }

  /* Réduit jusqu'à 1–9, en s'arrêtant sur 11, 22 ou 33. */
  function reduire(valeur) {
    var etapes = [];
    var courant = valeur;
    while (courant > 9 && MAITRES.indexOf(courant) < 0) {
      var chiffres = chiffresDe(courant);
      var suivant = chiffres.reduce(function (a, c) { return a + c; }, 0);
      etapes.push({ expression: chiffres.join(' + '), resultat: suivant });
      courant = suivant;
    }
    return { valeur: courant, etapes: etapes };
  }

  function deuxChiffres(n) { return n < 10 ? '0' + n : String(n); }

  /* JJMMAAAA, chiffre par chiffre. Les zéros sont conservés dans l'expression
     affichée même s'ils ne changent pas la somme : l'utilisateur doit retrouver
     sa date exacte dans le détail du calcul. */
  function calculerCheminDeVie(jour, mois, annee) {
    var suite = deuxChiffres(nombre(jour)) + deuxChiffres(nombre(mois)) + String(nombre(annee));
    var chiffres = suite.split('').map(Number);
    var somme = chiffres.reduce(function (a, c) { return a + c; }, 0);

    var etapes = [{ expression: chiffres.join(' + '), resultat: somme }];
    var reduction = reduire(somme);
    etapes = etapes.concat(reduction.etapes);

    var valeur = reduction.valeur;
    var maitre = MAITRES.indexOf(valeur) >= 0;
    var racine = maitre ? reduire(chiffresDe(valeur).reduce(function (a, c) { return a + c; }, 0)).valeur : null;

    return {
      nombre: valeur,
      affichage: maitre ? valeur + '/' + racine : String(valeur),
      nombreMaitre: maitre,
      racine: racine,
      etapes: etapes
    };
  }

  /* Le texte de partage ne prend QUE le résultat déjà calculé, jamais la date.
     La signature l'interdit structurellement : impossible de lui passer un jour. */
  function texteDePartage(resultat) {
    if (resultat && (resultat.jour !== undefined || resultat.mois !== undefined
        || resultat.annee !== undefined || resultat.etapes)) {
      throw new Error('texteDePartage ne doit recevoir que le nombre, jamais la date ni le calcul');
    }
    return 'J’ai calculé mon chemin de vie avec l’outil gratuit DailyLama.';
  }

  /* Assainisseur de mesure : liste blanche stricte. Tout ce qui dérive de la date —
     y compris le nombre obtenu — est refusé, pas seulement ignoré. */
  var PROPRIETES_AUTORISEES = ['source_page', 'validation_error_type', 'share_method', 'article_available'];
  var PROPRIETES_INTERDITES = ['day', 'month', 'year', 'birth_date', 'age', 'result_number',
    'display_result', 'calculation_steps', 'name', 'email', 'free_text',
    'jour', 'mois', 'annee', 'nombre', 'affichage', 'etapes', 'date'];

  function assainirMesure(props) {
    var sortie = {};
    if (!props || typeof props !== 'object') return sortie;
    Object.keys(props).forEach(function (cle) {
      if (PROPRIETES_INTERDITES.indexOf(cle) >= 0) {
        throw new Error('propriété interdite dans la mesure : ' + cle);
      }
      if (PROPRIETES_AUTORISEES.indexOf(cle) >= 0) sortie[cle] = props[cle];
    });
    return sortie;
  }

  global.DailyLamaCheminDeVie = {
    validerDate: validerDate,
    calculerCheminDeVie: calculerCheminDeVie,
    reduire: reduire,
    texteDePartage: texteDePartage,
    assainirMesure: assainirMesure,
    ANNEE_MIN: ANNEE_MIN,
    MAITRES: MAITRES,
    PROPRIETES_AUTORISEES: PROPRIETES_AUTORISEES,
    PROPRIETES_INTERDITES: PROPRIETES_INTERDITES
  };

  /* ------------------------------------------------------------------ */
  /* Contenu éditorial                                                   */
  /* ------------------------------------------------------------------ */

  /* Copie rédigée et relue, reprise telle quelle de la maquette Claude Design.
     Formulations imposées : « traditionnellement associé à », « cette lecture
     symbolique met en avant ». Aucune promesse de santé, d'argent ou d'amour,
     aucune hiérarchie entre les nombres. */
  var CONTENU = {
    1: { titre: 'L’initiateur', bref: 'Initiative, autonomie, envie d’ouvrir la voie.',
      corps: 'Traditionnellement associé à l’élan et à l’initiative. Cette lecture symbolique met en avant le besoin d’avancer par soi-même et de décider sans attendre la permission des autres.',
      forces: ['Capacité à démarrer ce que d’autres reportent', 'Autonomie de décision', 'Clarté dans la direction choisie'],
      vigilance: ['L’impatience quand le rythme collectif ralentit', 'La difficulté à déléguer', 'Le risque de confondre indépendance et isolement'],
      pistes: ['Quelle décision reportez-vous en attendant l’accord de quelqu’un ?', 'Où l’autonomie vous sert-elle, où vous coupe-t-elle ?', 'Quel projet mériterait d’être lancé cette année ?'] },
    2: { titre: 'Le conciliateur', bref: 'Écoute, lien, sens du rythme des autres.',
      corps: 'Traditionnellement associé à la relation et à l’écoute. Cette lecture symbolique met en avant une sensibilité aux équilibres entre les personnes et un talent pour désamorcer les tensions.',
      forces: ['Perception fine des non-dits', 'Aptitude à créer du lien durable', 'Patience dans les situations tendues'],
      vigilance: ['S’effacer pour préserver l’harmonie', 'La difficulté à trancher', 'L’absorption des tensions des autres'],
      pistes: ['Où avez-vous cédé récemment sans le vouloir vraiment ?', 'Quelle limite gagnerait à être posée ?', 'À qui pourriez-vous dire non cette semaine ?'] },
    3: { titre: 'Le créatif expressif', bref: 'Expression, imagination, goût du partage.',
      corps: 'Traditionnellement associé à l’expression et à la créativité. Cette lecture symbolique met en avant un besoin de traduire ce que vous ressentez en mots, en images ou en gestes.',
      forces: ['Aisance à formuler et à raconter', 'Imagination fertile', 'Capacité à réchauffer une atmosphère'],
      vigilance: ['La dispersion entre trop d’envies', 'La difficulté à finir ce qui est commencé', 'Le besoin de retours extérieurs'],
      pistes: ['Quelle création avez-vous laissée en suspens ?', 'Où vous censurez-vous par peur du jugement ?', 'Quel format vous ressemble le plus aujourd’hui ?'] },
    4: { titre: 'Le bâtisseur', bref: 'Méthode, patience, sens du concret.',
      corps: 'Traditionnellement associé à la construction et à la constance. Cette lecture symbolique met en avant le goût du travail méthodique et la satisfaction de voir une base tenir dans le temps.',
      forces: ['Fiabilité reconnue par l’entourage', 'Sens de l’organisation', 'Endurance sur les projets longs'],
      vigilance: ['La rigidité face à l’imprévu', 'La tendance à surcharger son planning', 'La difficulté à s’autoriser une pause'],
      pistes: ['Quelle routine vous protège, laquelle vous enferme ?', 'Où pourriez-vous accepter l’imprévu ?', 'Qu’avez-vous construit dont vous êtes fier ?'] },
    5: { titre: 'L’explorateur', bref: 'Mouvement, curiosité, besoin d’air.',
      corps: 'Traditionnellement associé au changement et à l’expérience. Cette lecture symbolique met en avant un besoin de mouvement et une curiosité qui pousse à essayer plutôt qu’à théoriser.',
      forces: ['Adaptation rapide aux situations nouvelles', 'Curiosité qui ouvre des portes', 'Aisance dans l’imprévu'],
      vigilance: ['La fuite quand la routine s’installe', 'L’engagement long qui pèse', 'La dispersion des expériences'],
      pistes: ['Qu’est-ce que vous fuyez quand vous partez ?', 'Quel engagement mériterait d’être tenu jusqu’au bout ?', 'Quelle liberté vous manque concrètement ?'] },
    6: { titre: 'Le gardien attentif', bref: 'Soin, responsabilité, sens du foyer.',
      corps: 'Traditionnellement associé au soin et à la responsabilité. Cette lecture symbolique met en avant une attention naturelle au bien-être des proches et un sens aigu de ce qui est juste.',
      forces: ['Présence rassurante pour l’entourage', 'Sens des responsabilités', 'Attention aux détails qui comptent'],
      vigilance: ['Porter ce qui ne vous appartient pas', 'Le contrôle déguisé en attention', 'L’oubli de vos propres besoins'],
      pistes: ['Quelle charge portez-vous à la place de quelqu’un ?', 'Où l’aide devient-elle du contrôle ?', 'Quand avez-vous pris soin de vous ?'] },
    7: { titre: 'Le chercheur intérieur', bref: 'Observation, réflexion, besoin de comprendre.',
      corps: 'Traditionnellement associé à l’observation et à la réflexion. Cette lecture symbolique met en avant un besoin de comprendre avant d’agir, et une aisance dans les moments passés seul. Le 7 peut inviter à chercher le sens derrière les évidences plutôt qu’à suivre le mouvement général.',
      forces: ['Recul dans les situations confuses', 'Capacité d’analyse et de nuance', 'À l’aise dans la solitude choisie'],
      vigilance: ['L’analyse qui remplace la décision', 'La distance prise pour se protéger', 'L’exigence envers soi et les autres'],
      pistes: ['Quelle décision attend une certitude qui ne viendra pas ?', 'Où le recul devient-il de l’évitement ?', 'À qui pourriez-vous parler de ce que vous cherchez ?'] },
    8: { titre: 'Le stratège', bref: 'Ambition, structure, rapport au concret.',
      corps: 'Traditionnellement associé à l’action structurée et au rapport aux ressources. Cette lecture symbolique met en avant une vision d’ensemble et une capacité à transformer une intention en organisation.',
      forces: ['Vision d’ensemble des situations', 'Détermination dans l’effort', 'Aisance à décider vite'],
      vigilance: ['Mesurer sa valeur à ses résultats', 'La difficulté à s’arrêter', 'Le contrôle exercé sur les autres'],
      pistes: ['Que cherchez-vous vraiment à prouver ?', 'Quel succès ne vous a rien apporté ?', 'Où pourriez-vous lâcher la conduite ?'] },
    9: { titre: 'L’accompagnant', bref: 'Générosité, ouverture, sens du collectif.',
      corps: 'Traditionnellement associé à l’ouverture et au don. Cette lecture symbolique met en avant une attention à ce qui dépasse le cercle proche et une capacité à accompagner les fins de cycle.',
      forces: ['Empathie large, au-delà du cercle proche', 'Capacité à lâcher ce qui est terminé', 'Sens du collectif'],
      vigilance: ['Se donner jusqu’à l’épuisement', 'L’idéalisation des situations', 'La difficulté à recevoir'],
      pistes: ['Que continuez-vous à porter alors que c’est fini ?', 'Où pourriez-vous accepter de l’aide ?', 'Quelle cause vous tient vraiment ?'] },
    11: { titre: 'L’inspirateur intuitif', bref: 'Sensibilité fine, intuition, besoin de sens.',
      corps: 'Traditionnellement associé à l’intuition et à la sensibilité. Cette lecture symbolique met en avant une perception fine des ambiances et un besoin de sens qui dépasse le confort immédiat.',
      forces: ['Intuition rapide dans les situations humaines', 'Capacité à inspirer sans forcer', 'Sensibilité aux atmosphères'],
      vigilance: ['La saturation nerveuse', 'Le doute qui suit l’intuition', 'L’écart entre l’idéal et le quotidien'],
      pistes: ['Quelle intuition avez-vous ignorée récemment ?', 'Comment protégez-vous votre énergie ?', 'Quel cadre concret donnerait forme à vos idées ?'] },
    22: { titre: 'Le bâtisseur visionnaire', bref: 'Projets de long terme, patience, structure.',
      corps: 'Traditionnellement associé aux projets de long terme. Cette lecture symbolique met en avant une capacité à tenir une vision large tout en construisant pièce par pièce.',
      forces: ['Vision large tenue dans la durée', 'Sens pratique au service d’une idée', 'Patience structurante'],
      vigilance: ['La pression que vous vous imposez', 'L’ampleur des projets qui paralyse', 'La difficulté à célébrer les étapes'],
      pistes: ['Quelle première pierre pourriez-vous poser cette semaine ?', 'Quelle exigence pourriez-vous relâcher ?', 'Qui pourrait construire avec vous ?'] },
    33: { titre: 'Le guide bienveillant', bref: 'Transmission, soin des autres, responsabilité.',
      corps: 'Traditionnellement associé à la transmission et au soin. Cette lecture symbolique met en avant une attention aux autres qui prend souvent la forme d’un accompagnement ou d’un enseignement.',
      forces: ['Attention profonde portée aux autres', 'Aptitude à transmettre simplement', 'Constance dans le soin'],
      vigilance: ['Le poids de la responsabilité ressentie', 'L’oubli de ses propres limites', 'L’attente de reconnaissance'],
      pistes: ['Que transmettez-vous sans vous en rendre compte ?', 'Quelle limite protégerait votre énergie ?', 'Qui prend soin de vous ?'] }
  };

  /* Les douze nombres ont désormais leur article, vérifiés en ligne le 26/08/2026.
     Le guide général reste comme repli si un article venait à disparaître.
     Le libellé du 4 et du 7 dit ce que l'article traite réellement : le 7 ne parle
     que de compatibilité, le 4 aborde le nombre sous l'angle amoureux. */
  var GUIDE_GENERAL = {
    url: '/blogs/spiritualite/la-numerologie-pythagoricienne-la-danse-cosmique-des-chiffres-de-votre-ame',
    libelle: 'La numérologie pythagoricienne, pas à pas',
    general: true
  };

  var ARTICLES = {
    1: { url: '/blogs/spiritualite/le-chemin-de-vie-1-en-numerologie-oser-etre-pionnier-de-sa-destinee',
         libelle: 'Chemin de vie 1 : oser être pionnier' },
    2: { url: '/blogs/spiritualite/le-chemin-de-vie-2-une-destinee-placee-sous-le-signe-de-lharmonie',
         libelle: 'Chemin de vie 2 : une destinée sous le signe de l’harmonie' },
    3: { url: '/blogs/spiritualite/chemin-de-vie-3-transcender-son-karma-par-la-creativite',
         libelle: 'Chemin de vie 3 : transcender son karma par la créativité' },
    4: { url: '/blogs/spiritualite/le-chemin-de-vie-4-en-amour-stabilite-et-devouement',
         libelle: 'Chemin de vie 4 en amour : stabilité et dévouement' },
    6: { url: '/blogs/spiritualite/le-chemin-de-vie-6-une-mission-damour-et-dharmonie',
         libelle: 'Chemin de vie 6 : une mission d’amour et d’harmonie' },
    5: { url: '/blogs/spiritualite/chemin-de-vie-5-signification-liberte-mouvement',
         libelle: 'Chemin de vie 5 : signification, liberté et mouvement' },
    7: { url: '/blogs/spiritualite/compatibilite-du-chemin-de-vie-7-explorer-les-liens-profonds',
         libelle: 'Compatibilité du chemin de vie 7 : explorer les liens profonds' },
    8: { url: '/blogs/spiritualite/chemin-de-vie-8-signification-karma-equilibre',
         libelle: 'Chemin de vie 8 : signification, karma et équilibre' },
    9: { url: '/blogs/spiritualite/chemin-de-vie-9-signification-sagesse-accomplissement',
         libelle: 'Chemin de vie 9 : signification, sagesse et accomplissement' },
    11: { url: '/blogs/spiritualite/chemin-de-vie-11-2-signification-nombre-maitre',
          libelle: 'Chemin de vie 11/2 : signification du nombre maître' },
    22: { url: '/blogs/spiritualite/chemin-de-vie-22-4-signification-nombre-maitre',
          libelle: 'Chemin de vie 22/4 : signification du nombre maître' },
    33: { url: '/blogs/spiritualite/chemin-de-vie-33-6-signification-nombre-maitre',
          libelle: 'Chemin de vie 33/6 : signification du nombre maître' }
  };

  function articlePour(nombre) {
    return ARTICLES[nombre] || GUIDE_GENERAL;
  }

  global.DailyLamaCheminDeVie.CONTENU = CONTENU;
  global.DailyLamaCheminDeVie.ARTICLES = ARTICLES;
  global.DailyLamaCheminDeVie.GUIDE_GENERAL = GUIDE_GENERAL;
  global.DailyLamaCheminDeVie.articlePour = articlePour;

  /* ------------------------------------------------------------------ */
  /* Couche DOM                                                          */
  /* ------------------------------------------------------------------ */

  var API_DEFAUT = 'https://api.dailylama.shop/v1';
  var apiBase = API_DEFAUT;
  var reseauActif = false;

  /* Toute propriété passe par l'assainisseur : une propriété interdite lève,
     elle n'est pas silencieusement retirée. Mieux vaut une erreur en développement
     qu'une date de naissance partie en production. */
  function pister(nom, props) {
    var propres;
    try {
      propres = assainirMesure(props);
    } catch (e) {
      if (global.console && console.error) console.error('[chemin-de-vie] ' + e.message);
      return;
    }
    try {
      global.dataLayer = global.dataLayer || [];
      global.dataLayer.push(Object.assign({ event: nom }, propres));
    } catch (e) {}
    try {
      global.dispatchEvent(new CustomEvent('dl:chemin-de-vie', { detail: { nom: nom, props: propres } }));
    } catch (e) {}
    if (!reseauActif) return;
    try {
      global.fetch(apiBase + '/events', {
        method: 'POST', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: nom, props: propres })
      }).catch(function () {});
    } catch (e) {}
  }

  /* Remonte le bloc dans le corps de l'article, à une profondeur donnée en pourcentage
     des paragraphes. Si le conteneur est introuvable, le bloc reste où il est :
     dégradation silencieuse plutôt que disparition. */
  function remonterDansArticle(racine) {
    var selecteurs = racine.getAttribute('data-cv-remonter');
    if (!selecteurs) return;
    var ratio = parseInt(racine.getAttribute('data-cv-profondeur') || '45', 10);
    /* C'est l'enveloppe de section qu'il faut déplacer, pas la seule racine. */
    var hote = racine.closest ? racine.closest('[id^="shopify-section"]') : null;
    hote = hote || racine;

    var conteneur = null;
    var candidats = selecteurs.split(',');
    for (var i = 0; i < candidats.length && !conteneur; i++) {
      conteneur = document.querySelector(candidats[i].trim());
    }
    if (!conteneur || conteneur.contains(hote)) return;

    var paragraphes = conteneur.querySelectorAll(':scope > p, :scope > div > p');
    if (!paragraphes.length) return;
    var rang = Math.min(Math.max(1, Math.round(paragraphes.length * ratio / 100)), paragraphes.length);
    var ancre = paragraphes[rang - 1];
    if (!ancre || !ancre.parentNode) return;
    ancre.parentNode.insertBefore(hote, ancre.nextSibling);
  }

  function monter(racine) {
    if (!racine || racine.dataset.dlcvMonte === 'oui') return null;
    racine.dataset.dlcvMonte = 'oui';
    remonterDansArticle(racine);
    apiBase = racine.getAttribute('data-api') || API_DEFAUT;
    reseauActif = racine.getAttribute('data-tracking') === '1';

    var $ = function (s) { return racine.querySelector(s); };
    var formulaire = $('[data-cv-form]');
    if (!formulaire) return null;

    var champs = {
      jour: $('[data-cv-jour]'),
      mois: $('[data-cv-mois]'),
      annee: $('[data-cv-annee]')
    };
    var erreurs = {
      jour: $('[data-cv-erreur="jour"]'),
      mois: $('[data-cv-erreur="mois"]'),
      annee: $('[data-cv-erreur="annee"]')
    };
    var zoneResultat = $('[data-cv-resultat]');
    var boutonPartage = $('[data-cv-partager]');
    var boutonRecalcul = $('[data-cv-recalculer]');
    var confirmation = $('[data-cv-confirmation]');
    var annonce = $('[data-cv-annonce]');
    var detail = $('[data-cv-detail]');

    var commence = false;

    function nettoyerErreurs() {
      Object.keys(champs).forEach(function (k) {
        if (!champs[k]) return;
        champs[k].setAttribute('aria-invalid', 'false');
        champs[k].classList.remove('dlcv__champ--erreur');
        if (erreurs[k]) { erreurs[k].textContent = ''; erreurs[k].hidden = true; }
      });
    }

    function afficherErreur(verdict) {
      nettoyerErreurs();
      var champ = champs[verdict.champ];
      var zone = erreurs[verdict.champ];
      if (champ) {
        champ.setAttribute('aria-invalid', 'true');
        champ.classList.add('dlcv__champ--erreur');
        champ.focus();
      }
      if (zone) { zone.textContent = verdict.message; zone.hidden = false; }
      pister('life_path_calculator_validation_error', { validation_error_type: verdict.code });
    }

    function texte(sel, valeur) {
      var el = zoneResultat.querySelector(sel);
      if (el) el.textContent = valeur;
      return el;
    }

    function liste(sel, valeurs) {
      var el = zoneResultat.querySelector(sel);
      if (!el) return;
      el.textContent = '';
      valeurs.forEach(function (v) {
        var li = document.createElement('li');
        li.textContent = v;
        el.appendChild(li);
      });
    }

    function afficherResultat(calcul) {
      var info = CONTENU[calcul.nombre];
      var art = articlePour(calcul.nombre);

      texte('[data-cv-nombre]', calcul.affichage);
      var badge = zoneResultat.querySelector('[data-cv-maitre]');
      if (badge) {
        badge.hidden = !calcul.nombreMaitre;
        if (calcul.nombreMaitre) badge.textContent = 'Nombre maître ' + calcul.nombre;
      }
      texte('[data-cv-titre]', info.titre);
      texte('[data-cv-corps]', info.corps);
      liste('[data-cv-forces]', info.forces);
      liste('[data-cv-vigilance]', info.vigilance);
      liste('[data-cv-pistes]', info.pistes);

      var etapes = zoneResultat.querySelector('[data-cv-etapes]');
      if (etapes) {
        etapes.textContent = '';
        calcul.etapes.forEach(function (e) {
          var li = document.createElement('li');
          li.textContent = e.expression + ' = ' + e.resultat;
          etapes.appendChild(li);
        });
      }

      var lien = zoneResultat.querySelector('[data-cv-article]');
      if (lien) {
        lien.href = art.url;
        var libelle = lien.querySelector('[data-cv-article-libelle]');
        if (libelle) libelle.textContent = art.libelle;
        var sur = lien.querySelector('[data-cv-article-sur]');
        if (sur) sur.textContent = art.general ? 'Guide général' : 'Article DailyLama';
      }

      if (confirmation) confirmation.hidden = true;
      if (detail) detail.open = false;
      zoneResultat.hidden = false;

      /* Une seule annonce, au moment du résultat. Le titre reçoit le focus :
         le lecteur d'écran lit le nombre sans qu'on ait à répéter une région live. */
      var titre = zoneResultat.querySelector('[data-cv-entete]');
      if (titre) titre.focus();
      if (annonce) annonce.textContent = 'Votre chemin de vie est ' + calcul.affichage + '.';

      pister('life_path_calculator_calculated', { article_available: !art.general });
    }

    formulaire.addEventListener('submit', function (e) {
      e.preventDefault();
      var verdict = validerDate(
        champs.jour ? champs.jour.value : '',
        champs.mois ? champs.mois.value : '',
        champs.annee ? champs.annee.value : ''
      );
      if (!verdict.ok) {
        if (zoneResultat) zoneResultat.hidden = true;
        afficherErreur(verdict);
        return;
      }
      nettoyerErreurs();
      /* Le calcul reste une variable locale : rien n'est stocké sur l'instance,
         rien n'est écrit ailleurs que dans le DOM affiché. */
      afficherResultat(calculerCheminDeVie(verdict.jour, verdict.mois, verdict.annee));
    });

    Object.keys(champs).forEach(function (k) {
      if (!champs[k]) return;
      champs[k].addEventListener('input', function () {
        // pas de valeur transmise : on signale seulement que la saisie a commencé
        if (!commence && champs[k].value.trim() !== '') {
          commence = true;
          pister('life_path_calculator_started', {});
        }
      });
    });

    if (detail) detail.addEventListener('toggle', function () {
      if (detail.open) pister('life_path_calculator_explanation_opened', {});
    });

    if (boutonRecalcul) boutonRecalcul.addEventListener('click', function () {
      Object.keys(champs).forEach(function (k) { if (champs[k]) champs[k].value = ''; });
      nettoyerErreurs();
      if (zoneResultat) zoneResultat.hidden = true;
      if (confirmation) confirmation.hidden = true;
      if (annonce) annonce.textContent = '';
      if (champs.jour) champs.jour.focus();
      pister('life_path_calculator_restarted', {});
    });

    if (boutonPartage) boutonPartage.addEventListener('click', function () {
      var url = racine.getAttribute('data-url-canonique') || location.origin + location.pathname;
      /* texteDePartage n'a jamais accès à la date : on ne lui passe rien d'autre
         qu'un objet vide, et sa signature refuse tout ce qui ressemble à un calcul. */
      var texteAPartager = texteDePartage({});

      function confirmer(methode) {
        if (confirmation) {
          confirmation.textContent = 'Résultat copié — votre date de naissance n’est pas incluse.';
          confirmation.hidden = false;
        }
        pister('life_path_calculator_share_clicked', { share_method: methode });
      }

      if (global.navigator && navigator.share) {
        navigator.share({ title: 'Calculateur de chemin de vie — DailyLama', text: texteAPartager, url: url })
          .then(function () { confirmer('web_share'); })
          .catch(function () {});
        return;
      }
      if (global.navigator && navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texteAPartager + ' ' + url)
          .then(function () { confirmer('clipboard'); })
          .catch(function () { confirmer('indisponible'); });
        return;
      }
      confirmer('indisponible');
    });

    racine.querySelectorAll('[data-cv-intention]').forEach(function (a) {
      a.addEventListener('click', function () {
        pister('life_path_calculator_intention_cta_clicked', {});
      });
    });
    racine.querySelectorAll('[data-cv-article]').forEach(function (a) {
      a.addEventListener('click', function () {
        pister('life_path_calculator_article_cta_clicked', {});
      });
    });

    pister('life_path_calculator_view', { source_page: location.pathname });
    return { validerDate: validerDate, calculerCheminDeVie: calculerCheminDeVie };
  }

  global.DailyLamaCheminDeVie.monter = monter;
  global.DailyLamaCheminDeVie.pister = pister;

  if (typeof document !== 'undefined') {
    var demarrage = function () {
      Array.prototype.slice.call(document.querySelectorAll('[data-cv-racine]')).forEach(monter);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrage);
    else demarrage();
  }
})(typeof window !== 'undefined' ? window : globalThis);
